import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7dd758b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "view-content",
  id: "main-application-scenarios"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "主要应用场景", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "多行业、全场景一体化数字健康管理解决方案", -1));
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "intro"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPTIONS, (item, i) => {
    return _openBlock(), _createElementBlock("li", {
      key: i
    }, [item ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("img", {
      src: item.icon,
      width: "80",
      height: "80"
    }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.intro), 1)], 64)) : _createCommentVNode("", true)]);
  }), 128))])]);
}